import { render } from "./isfc.vue?vue&type=template&id=eced71b4&scoped=true"
import script from "./isfc.vue?vue&type=script&lang=js"
export * from "./isfc.vue?vue&type=script&lang=js"

import "./isfc.vue?vue&type=style&index=0&id=eced71b4&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eced71b4"]])

export default __exports__